module.exports = __webpack_public_path__ + "img/icon_img12.png";